export default __webpack_public_path__ + "static/media/search-icon.22475ac2.png";